import { type Atom, useAtomValue } from "jotai";

export function StatusDisplay({ statusAtom }: { statusAtom: Atom<string | null> }) {
    const status = useAtomValue(statusAtom);
    if (status == null) {
        return null;
    }

    return <div className="color-muted p-1 my-2 b b-solid b-gray-3">{status}</div>;
}
